"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _webmidi = require("webmidi");

function enable(play) {
  _webmidi.WebMidi.enable().then(onEnabled).catch(function (error) {
    return console.error(error);
  });

  // Function triggered when WEBMIDI.js is ready
  function onEnabled() {
    // Display available MIDI input devices
    if (_webmidi.WebMidi.inputs.length < 1) {
      console.log("No device detected.");
      return;
    } else {
      _webmidi.WebMidi.inputs.forEach(function (device, index) {
        document.body.innerHTML += index + ": " + device.name + " <br>";
      });
      var mySynth = _webmidi.WebMidi.inputs[0];
      // const mySynth = WebMidi.getInputByName("TYPE NAME HERE!")

      mySynth.channels[1].addListener("noteon", function (event) {
        console.log(event.note);
      });
    }
  }
} /**
   * MIDI
   * @module midi.js;
   */

exports.default = { enable: enable };


//////////////////
// WEBPACK FOOTER
// ./client/lib/midi.js
// module id = 264
// module chunks = 0